import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { notification } from 'antd';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import { TextField, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, Link } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { getToken, getUser } from '../../utils/common';
import logger from '../../utils/logger';

const capitalizeFirst = (str) => {
  const str1 = str.split('_').join(' ');
  return str1.charAt(0).toUpperCase() + str1.slice(1);
};

// TextfieldCustom3 component moved outside parent component
const TextfieldCustom3 = ({
  id = '',
  size = '',
  tittle = '',
  placeholder = '',
  dropdown = [],
  label = '',
  multiline = false,
  disabled = false,
  onChange,
  indexdata = 0,
  namedata = '',
  rule = [],
  handleIncrementClick,
  datasuccess = '',
}) => (
  <Grid item md={size}>
    <Grid container direction={'column'} spacing={0}>
      <Grid item>
        <Typography variant="subtitle2">{tittle}</Typography>
      </Grid>
      <Grid item>
        {dropdown != '' ? (
          <Autocomplete
            fullWidth
            size="medium"
            disablePortal
            style={{ paddingTop: '3vh' }}
            value={(dropdown || []).find((e) => e[label] === rule[indexdata]?.[namedata])}
            disabled={datasuccess === 'nodata'}
            id={id}
            onChange={(event, newValue) => {
              handleIncrementClick(indexdata, namedata, newValue[label]);
            }}
            options={dropdown}
            getOptionLabel={(dropdown) => (dropdown && dropdown[label]) || ''}
            getOptionSelected={(option, selectedValue) => option[label] === selectedValue[label]}
            renderInput={(params) => <TextField {...params} fullWidth placeholder={capitalizeFirst(id)} />}
          />
        ) : (
          <TextField
            fullWidth
            id={id}
            disabled={datasuccess === 'nodata'}
            multiline={multiline}
            style={{ paddingTop: '2vh' }}
            name={id}
            size="small"
            placeholder={placeholder}
            value={rule[indexdata]?.[namedata]}
            onChange={(e) => {
              handleIncrementClick(indexdata, namedata, e.target.value);
            }}
          />
        )}
      </Grid>
    </Grid>
  </Grid>
);

TextfieldCustom3.propTypes = {
  id: PropTypes.string,
  size: PropTypes.string,
  tittle: PropTypes.string,
  placeholder: PropTypes.string,
  dropdown: PropTypes.array,
  label: PropTypes.string,
  multiline: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  indexdata: PropTypes.number,
  namedata: PropTypes.string,
  rule: PropTypes.array,
  handleIncrementClick: PropTypes.func,
  datasuccess: PropTypes.string,
};
export default function Pekerja(props) {
  const [rule, setRule] = React.useState([]);
  const [listassign, setlistassign] = React.useState([]);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const dataset = params.get('dataset');
  const [assign, setassign] = React.useState({
    id: dataset,
  });
  const [datasuccess, setdatasuccess] = React.useState('');
  const [user] = React.useState(getUser());
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const save = async () => {
    const item = {
      action_name: formData.name,
      description: formData.description,
      steps: rule,
      assign: assign?.id,
    };
    try {
      setIsLoading(true);
      const response = await fetch(`${globalThis.REACT_APP_API_PURE}action/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(item),
      });
      const data = await response.json();

      if (data && data.response_code === 200) {
        notification.success({
          message: 'Success',
          description: t('ActionAdd.1'),
          placement: 'top',
          duration: 5,
        });
      } else {
        notification.warning({
          message: 'Warning',
          description: t('ActionAdd.2'),
          placement: 'top',
          duration: 5,
        });
      }
    } catch (error) {
      logger.error('Error:', error);
    }
    setTimeout(() => {
      setIsLoading(false);
      globalThis.history.go(-1);
    }, 4000);
  };
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(rule);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setRule(items);
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(`${globalThis.REACT_APP_API_PURE}actions/listassign`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
      });
      const data = await response.json();
      if (data === null) {
        notification.error({
          message: 'Error',
          description: t('NoDatasetprompt.1'),
          placement: 'top',
          duration: 5,
        });
        setdatasuccess('nodata');
      } else {
        setlistassign(data);
      }
    };
    fetchData();
  }, []);

  function handleIncrementClick(index, value, e) {
    const nextCounters = rule.map((c, i) => {
      if (i === index) {
        return { ...c, [value]: e };
      }

      return c;
    });
    setRule(nextCounters);
  }

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    steps: [],
  });

  function CardBack() {
    return (
      <Grid container direction={'row'}>
        <Grid item>
          <Link onClick={() => globalThis.history.go(-1)}>
            <IconButton style={{ color: '#1EB3D9' }}>
              <ArrowBackIcon />
            </IconButton>
          </Link>
        </Grid>
        <Grid item alignSelf={'center'}>
          <Typography variant="h4">{t('AddActions.1')}</Typography>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <p style={{ fontSize: '16px' }}>
              {t('LastEdited.1')} {user || ''}
            </p>
          </div>
        </Grid>
      </Grid>
    );
  }
  notification.config({
    placement: 'top',
    duration: 5,
  });
  const handleAddStep = () => {
    const nextStep = rule.length > 0 ? rule.at(-1).step + 1 : 1;
    const newStep = {
      step: nextStep,
      description: '',
    };
    setRule((prevRule) => [...prevRule, newStep]);
  };

  const handleDeleteStep = (stepToDelete) => {
    const filteredRule = rule.filter((item) => item.step !== stepToDelete); // Remove the deleted step from the rule array
    setRule(filteredRule);

    // Ensure unique steps by reassigning step numbers
    const updatedRule = filteredRule.map((item, index) => ({
      ...item,
      step: index + 1,
    }));
    setRule(updatedRule);
  };
  useEffect(() => {
    if (rule.length === 0) {
      setRule([...rule, { step: 1, description: '' }]); // Add a default rule
    }
  }, [rule, setRule]);

  return (
    <span>
      <Paper
        style={{
          padding: 20,
          minHeight: '80vh',
          backgroundColor: '#fafafc',
          boxShadow: 'none',
        }}
      >
        <Stack direction="row" justifyContent="space-between" mb={5}>
          {CardBack()}
        </Stack>

        <Stack direction={'row'} spacing={3} className="main">
          <div className="clm-1">
            <p style={{ fontSize: '18px' }}>{t('NameActions.1')}</p>
            <br />
            <TextField
              disabled={datasuccess === 'nodata'}
              id="outlined-basic"
              label={t('NameActions.1')}
              variant="outlined"
              autoComplete="off"
              style={{ width: '20rem' }}
              value={formData.name}
              onChange={(event) => {
                const newName = event.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  name: newName,
                }));
              }}
            />
          </div>
          <div className="clm-2" style={{ flex: 1 }}>
            <p style={{ fontSize: '18px' }}>{t('Deskripsyong.1')}</p>
            <br />
            <TextField
              disabled={datasuccess === 'nodata'}
              id="outlined-basic"
              label={t('Deskripsyong.1')}
              variant="outlined"
              autoComplete="off"
              style={{ paddingBottom: '2vh' }}
              fullWidth
              value={formData.description}
              onChange={(event) => {
                const newDescription = event.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  description: newDescription,
                }));
              }}
            />
          </div>
        </Stack>
        <div className="clm-1" style={{ flex: 1 }}>
          <p style={{ fontSize: '18px' }}>{t('AssignDataset.1')}</p>
          <br />
          <Grid item md={4}>
            <Grid container direction={'column'}>
              <Grid item>
                <Autocomplete
                  fullWidth
                  size="small"
                  disabled={dataset !== null}
                  disablePortal
                  value={assign || ''}
                  onChange={(event, newValue) => {
                    setassign(newValue);
                  }}
                  options={listassign || []}
                  getOptionLabel={(listassign) => listassign?.id || ''}
                  getOptionSelected={(option, selectedValue) => option.id === selectedValue.id}
                  renderInput={(params) => (
                    <TextField key={'assign'} {...params} fullWidth placeholder={t('ActionAdd.3')} />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </div>
        <div className="horizontal-line"> </div>
        <div className="step">
          <p style={{ fontSize: '18px', marginTop: '10px' }}>{t('Step.1')}</p>
          <Grid item xs={12}>
            <Paper style={{ padding: 10 }}>
              <Grid xs={12} container direction={'column'} spacing={1}>
                <Grid item container direction={'row'}>
                  {' '}
                </Grid>
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="droppable">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {rule.map((item, index) => (
                          <Draggable key={`step-${item.step}`} draggableId={item.step.toString()} index={index}>
                            {(provided) => (
                              <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                {TextfieldCustom3({
                                  id: 'description',
                                  size: 12,
                                  tittle: t('Deskripsyong.2'),
                                  label: 'id',
                                  indexdata: index,
                                  namedata: 'description',
                                  multiline: true,
                                  dropdown: '',
                                  rule,
                                  handleIncrementClick,
                                  datasuccess,
                                })}
                                <Grid item xs>
                                  {''}
                                </Grid>
                                <Grid item>
                                  {rule.length > 1 && (
                                    <Button
                                      key={item.step}
                                      variant="contained"
                                      endIcon={<DeleteIcon />}
                                      style={{
                                        textTransform: 'none',
                                        backgroundColor: 'rgba(255, 255, 160, 0.5)',
                                        color: 'red',
                                        float: 'right',
                                      }}
                                      onClick={() => handleDeleteStep(item.step)}
                                    >
                                      {t('DeleteStep.1')}
                                    </Button>
                                  )}
                                </Grid>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
                <Grid item xs>
                  {''}
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <div style={{ paddingTop: '15px' }}>
            <Button
              disabled={datasuccess === 'nodata'}
              variant="outlined"
              fullWidth
              startIcon={<AddIcon />}
              onClick={handleAddStep}
            >
              {t('MoreStep.1')}
            </Button>
          </div>
          <div
            style={{
              paddingTop: '15px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {rule.length >= 1 ? (
              <LoadingButton
                loading={isLoading}
                disabled={isLoading}
                className="bg-sky-500 shadow-lg shadow-blue-500/50 text-white outline outline-offset-3 w-full"
                style={{ backgroundColor: isLoading ? 'gray' : '#12A2CE', color: 'white' }}
                loadingPosition="start"
                onClick={
                  formData.name && formData.description && assign.id !== null
                    ? save
                    : () =>
                        notification.error({
                          message: 'Error',
                          description: t('PromptDatanotFull.1'),
                          placement: 'top',
                          duration: 5,
                        })
                }
              >
                {t('Done.1')}
              </LoadingButton>
            ) : (
              ''
            )}
          </div>
        </div>
      </Paper>
    </span>
  );
}
